import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {useContext} from "react";
import ModalContext from "./envResultsTable/ModalContext";
import Succeed from "../../assets/createEnvAssets/Succeed";
import styled from "styled-components";
import FailedIcon from "../../assets/createEnvAssets/FailedIcon";
import CancelIcon from "../../assets/createEnvAssets/CancelIcon";
import {Line} from "./SalesForceFailedModal";

export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    textAlign: 'center',
    borderRadius: 2,
};

const StaticModalStyle = styled.div`
  text-align: start;
  padding: 0px 25px 24px 25px;
`;


const CancelButtonWrapper = styled.div`
  display: flex;
  justify-content: end;

  .cancel_button {
    width: 10px;
    cursor: pointer;
  }
`;

const MessageContent = styled.p`
  font-size: 13px;
`;

const MessageWrapper = styled.div`
  padding: 10px;
`;

const Button = styled.button`

  width: 155px;
  background: var(--color-brand-pink-primary);
  color: white;
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  display: inline;

  &:hover {
    background: #fa105b;
  }
`;

const StaticContent = styled.div`
  font-size: small;

  .credentials_style {
    font-weight: bold;
    font-size: 14px;
  }
`;

export default function BasicModal() {
    const {
        basicModalIsOpen,
        setBasicModalIsOpen,
        envUrl,
        contentMessage,
        isInvitation,
        setContentMessage
    } = useContext(ModalContext);
    const [firstMessage, secondMessage, blueprintName, environmentCredentials, environmentCloudType, isSuccess] = contentMessage;
    const onCloseModal = () => {
        setBasicModalIsOpen(false)
        setContentMessage("");
    }
    if (environmentCloudType === "STATIC") {
        const credentials = environmentCredentials.split("\n");
        return (
            <div>
                <Modal
                    open={basicModalIsOpen}
                    onClose={onCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style} id={"static-modal"}>
                        <CancelButtonWrapper>
                                <span className={"cancel_button"} onClick={onCloseModal}>
                                    <CancelIcon/>
                                </span>
                        </CancelButtonWrapper>
                        {isSuccess ? <Succeed/> : <FailedIcon/>}
                        {firstMessage?.length > 0 &&
                            <>
                                <MessageWrapper id={"message-wrapper"}>
                                    <MessageContent className={"MessageContent"}
                                                    id={"first-message"}>{firstMessage}</MessageContent>
                                    <MessageContent className={"MessageContent"}
                                                    id={"second-message"}>{secondMessage}</MessageContent>
                                </MessageWrapper>
                                <Line/>
                            </>
                        }
                        <StaticModalStyle>
                            <h4>
                                {blueprintName}
                            </h4>
                            {
                                <StaticContent>
                                    <div id={"username"} className={"credentials_style"}>
                                        {credentials[0]}
                                    </div>
                                    <div id={"password"} className={"credentials_style"}>
                                        {credentials[1]}
                                    </div>
                                    <div id={"more_content"} className={"credentials_style"}>
                                        {credentials[2]}

                                    </div>
                                </StaticContent>
                            }
                        </StaticModalStyle>
                        <Button onClick={() => window.open(envUrl, "_blank")} className={"go_to_env_btn"}>Go to My
                            Environment</Button>
                    </Box>
                </Modal>
            </div>
        );
    } else {
        return (
            <div>
                <Modal
                    open={basicModalIsOpen}
                    onClose={onCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style} id={"basic-modal"}>
                        {envUrl === "" && !isInvitation ?
                            <FailedIcon/>
                            :
                            <>
                                <CancelButtonWrapper>
                                <span className={"cancel_button"} onClick={onCloseModal}>
                                    <CancelIcon/>
                                </span>
                                </CancelButtonWrapper>
                                <Succeed/>
                            </>
                        }
                        <MessageWrapper id={"message-wrapper"}>
                            <MessageContent id={"first-message"}>{firstMessage}</MessageContent>
                            <MessageContent id={"second-message"}>{secondMessage}</MessageContent>
                        </MessageWrapper>
                        {envUrl === "" || isInvitation ?
                            <Button onClick={ onCloseModal}>Close</Button> :
                            <Button onClick={() => window.open(envUrl, "_blank")} className={"go_to_env_btn"}>Go to My
                                Environment</Button>}
                    </Box>
                </Modal>
            </div>
        );
    }
}
